import { useReadOnly } from 'utils/lifecycle'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import { Box, Button, Card, CardActions, CardContent, Grid, Typography } from '@mui/material'
import { ConfirmationDialog } from 'components'
import PaymentPopup from '../../components/PaymentPopup'
import PaymentCard from '../../components/PaymentCard'
import AccountPage from '../../components/AccountPage'
import AutoReloadButton from 'modules/Business/components/AutoReloadButton'
import SetReload from 'modules/Business/modules/Credits/components/SetReload'

const Payment = () => {
  const readOnly = useReadOnly()
  const [formOpened, setFormOpened] = useState(false)
  const [reloadOpened, setReloadOpened] = useState(false)
  const cards = useSelector(state => get(state, 'user.details.cards'))
  const business = useSelector(state => state.business)

  return (
    <AccountPage title="Payment">
      <Box p={2} pt={0} display="flex" alignItems="center" flexWrap="wrap" gap={1}>
        <Button disabled={readOnly} variant="contained" color="primary" disableElevation onClick={() => setFormOpened(true)}>
          Add new card
        </Button>
        {business?.businessId && cards?.length > 0 && (
          <AutoReloadButton disabled={readOnly}
            business={business}
            onClick={() => setReloadOpened(true)}
          />
        )}
      </Box>
      <Box p={2}>
        <Grid container spacing={3} alignItems="stretch">
          {
            cards && !!cards.length ?
            cards.map(c => (
              <Grid item xs={12} sm={6} lg={4}>
                <PaymentCard card={c} />
              </Grid>  
            ))
            :
            <Grid item xs={12} sm={6} lg={4}>
              <Card>
                <CardContent>
                  <Typography gutterBottom variant="h6" component="h2">
                    Payment method
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    You need credit card to fund your offers
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button disabled={readOnly} color="primary" onClick={() => setFormOpened(true)}>
                    Add payment method
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          }
        </Grid>
      </Box>
      {
        formOpened && !readOnly &&
        <PaymentPopup onClose={() => setFormOpened(false)} />
      }
      {reloadOpened && !readOnly && (
        <SetReload
          businessId={business.businessId}
          onClose={() => setReloadOpened(false)}
        />
      )}
      {
        <ConfirmationDialog />
      }
    </AccountPage>
  )
}

export default Payment
